module.exports = __webpack_public_path__ + "img/9788982739743.849bd488.jpg";